<template>
  <ScrollShadow>
    <div class="selected-products">
      <slot name="title" />
      <hr class="selected-products-divider" />
      <slot name="content" />
    </div>
  </ScrollShadow>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { ScrollShadow } from '@warrenbrasil/nebraska-web';

@Component({
  components: { ScrollShadow }
})
export default class ProductDetail extends Vue {}
</script>

<style lang="less" scoped>
.selected-products {
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  border: 1px solid @divider-primary;
  box-sizing: border-box;
  border-radius: 8px;
  padding: @size-spacing-x400;
}

.selected-products-divider {
  border-top: 1px solid @divider-primary;
  width: 100%;
}
</style>
